import { ModuleLayout, Space } from '@billy/design-system'
import React, { ReactNode } from 'react'

import { ProgressBar } from './elements/ProgressBar'
import * as Styled from './styles'

interface StepBasedFormBaseProps {
  onBack: () => void
  children: ReactNode
}

interface StepBasedFormWithoutProgressBar extends StepBasedFormBaseProps {
  withProgressBar?: false
  currentStep?: never
  totalSteps?: never
  stepLabels?: never
}

interface StepBasedFormWithProgressBar extends StepBasedFormBaseProps {
  withProgressBar: true
  currentStep: number
  totalSteps: number
  stepLabels: string[]
}

type StepBasedFormProps = StepBasedFormWithoutProgressBar | StepBasedFormWithProgressBar

export const StepBasedForm = ({
  onBack,
  withProgressBar = false,
  currentStep,
  totalSteps,
  stepLabels,
  children,
}: StepBasedFormProps) => {
  return (
    <ModuleLayout withBackButton onBackButtonClick={onBack}>
      <Styled.FormModuleWrapper>
        {withProgressBar ? (
          <>
            <ProgressBar currentStep={currentStep} totalSteps={totalSteps} stepLabels={stepLabels} />
            <Space size="s80" />
          </>
        ) : null}
        {children}
      </Styled.FormModuleWrapper>
    </ModuleLayout>
  )
}
